import { apiClient } from '_app'
import { CancelToken } from 'axios'
import { download } from 'utils'

const baseUrl = (): string => `/api/documents`

export const downloadFileName = (fileName: string, cancelToken?: CancelToken) =>
  apiClient.get(`${baseUrl()}/${encodeURIComponent(fileName)}`, { cancelToken }).then(res => {
    download(res.data, fileName, 'application/octet-stream')
  })
